/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import { Button, Form, Card, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { useEffect } from 'react';
import axios from 'axios';
import { set, format, addDays, parse } from 'date-fns';
import _ from 'lodash';

export const UpdateSubscription = ({ availableOpenTimes, postUrl }: any) => {
  const [openTime, setOpenTime] = useState('');
  const [openDayOfWeek, setOpenDayOfWeek] = useState('');

  const [selectedMondayOpenTimeOption, setSelectedMondayOpenTimeOption] = useState(null);
  const [selectedTuesdayOpenTimeOption, setSelectedTuesdayOpenTimeOption] = useState(null);
  const [selectedWednesdayOpenTimeOption, setSelectedWednesdayOpenTimeOption] = useState(null);
  const [selectedThursdayOpenTimeOption, setSelectedThursdayOpenTimeOption] = useState(null);
  const [selectedFridayOpenTimeOption, setSelectedFridayOpenTimeOption] = useState(null);

  const [availableMondayOpenTimes, setAvailableMondayOpenTimes] = useState([]);
  const [availableTuesdayOpenTimes, setAvailableTuesdayOpenTimes] = useState([]);
  const [availableWednesdayOpenTimes, setAvailableWednesdayOpenTimes] = useState([]);
  const [availableThursdayOpenTimes, setAvailableThursdayOpenTimes] = useState([]);
  const [availableFridayOpenTimes, setAvailableFridayOpenTimes] = useState([]);

  const [loading, setLoading] = useState(false);

  const csrfToken = (document.querySelector('[name=csrf-token]') as any)?.content;

  /* Utils */

  /* Generate contents from state */
  const isFormValid = () => {
    return openTime;
  };

  /* State hooks */
  useEffect(() => {
    setOpenTime('');
    setOpenDayOfWeek('');
    setAvailableMondayOpenTimes(availableOpenTimes['monday']);
    setAvailableTuesdayOpenTimes(availableOpenTimes['tuesday']);
    setAvailableWednesdayOpenTimes(availableOpenTimes['wednesday']);
    setAvailableThursdayOpenTimes(availableOpenTimes['thursday']);
    setAvailableFridayOpenTimes(availableOpenTimes['friday']);
  }, [availableOpenTimes]);

  useEffect(() => {
    if (selectedMondayOpenTimeOption != null) {
      setOpenTime(selectedMondayOpenTimeOption.value);
      setOpenDayOfWeek('monday');
      setSelectedTuesdayOpenTimeOption(null);
      setSelectedWednesdayOpenTimeOption(null);
      setSelectedThursdayOpenTimeOption(null);
      setSelectedFridayOpenTimeOption(null);
    }
  }, [selectedMondayOpenTimeOption]);

  useEffect(() => {
    if (selectedTuesdayOpenTimeOption != null) {
      setOpenTime(selectedTuesdayOpenTimeOption.value);
      setOpenDayOfWeek('tuesday');
      setSelectedMondayOpenTimeOption(null);
      setSelectedWednesdayOpenTimeOption(null);
      setSelectedThursdayOpenTimeOption(null);
      setSelectedFridayOpenTimeOption(null);
    }
  }, [selectedTuesdayOpenTimeOption]);

  useEffect(() => {
    if (selectedWednesdayOpenTimeOption != null) {
      setOpenTime(selectedWednesdayOpenTimeOption.value);
      setOpenDayOfWeek('wednesday');
      setSelectedMondayOpenTimeOption(null);
      setSelectedTuesdayOpenTimeOption(null);
      setSelectedThursdayOpenTimeOption(null);
      setSelectedFridayOpenTimeOption(null);
    }
  }, [selectedWednesdayOpenTimeOption]);

  useEffect(() => {
    if (selectedThursdayOpenTimeOption != null) {
      setOpenTime(selectedThursdayOpenTimeOption.value);
      setOpenDayOfWeek('thursday');
      setSelectedMondayOpenTimeOption(null);
      setSelectedTuesdayOpenTimeOption(null);
      setSelectedWednesdayOpenTimeOption(null);
      setSelectedFridayOpenTimeOption(null);
    }
  }, [selectedThursdayOpenTimeOption]);

  useEffect(() => {
    if (selectedFridayOpenTimeOption != null) {
      setOpenTime(selectedFridayOpenTimeOption.value);
      setOpenDayOfWeek('friday');
      setSelectedMondayOpenTimeOption(null);
      setSelectedTuesdayOpenTimeOption(null);
      setSelectedWednesdayOpenTimeOption(null);
      setSelectedThursdayOpenTimeOption(null);
    }
  }, [selectedFridayOpenTimeOption]);

  /* JSX itself */
  return (
    <div>
      {loading && (
        <div
          style={{
            backgroundColor: 'white',
            zIndex: 10,
            opacity: 0.5,
            height: '100vh',
            fontSize: '60px',
          }}>
          Loading...
        </div>
      )}
      <Form action={postUrl} method="post">
        <input type="hidden" name="open_time" value={openTime} />
        <input type="hidden" name="open_day_of_week" value={openDayOfWeek} />
        <input name="_method" type="hidden" value="put" />
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <Form.Group controlId="input">
          <div>
            <Form.Label className={'label'}>変更ご希望の曜日・時間を選択してください</Form.Label>
            <p className="text-danger">
              ※ 選択肢に表示がない時間帯は現在満席となっております。ご了承くださいませ。
            </p>
            <Row>
              <Col md={3}>
                <Form.Label className={'label'}>月曜日</Form.Label>
                <Select
                  name="monday"
                  value={selectedMondayOpenTimeOption}
                  options={availableMondayOpenTimes.map((v) => {
                    return { value: v, label: v };
                  })}
                  onChange={(selectedOption: any) => {
                    setSelectedMondayOpenTimeOption(selectedOption);
                  }}
                />
              </Col>
              <Col md={3}>
                <Form.Label className={'label'}>火曜日</Form.Label>
                <Select
                  name="tuesday"
                  value={selectedTuesdayOpenTimeOption}
                  options={availableTuesdayOpenTimes.map((v) => {
                    return { value: v, label: v };
                  })}
                  onChange={(selectedOption: any) => {
                    setSelectedTuesdayOpenTimeOption(selectedOption);
                  }}
                />
              </Col>
              <Col md={3}>
                <Form.Label className={'label'}>水曜日</Form.Label>
                <Select
                  name="wednesday"
                  value={selectedWednesdayOpenTimeOption}
                  options={availableWednesdayOpenTimes.map((v) => {
                    return { value: v, label: v };
                  })}
                  onChange={(selectedOption: any) => {
                    setSelectedWednesdayOpenTimeOption(selectedOption);
                  }}
                />
              </Col>
              <Col md={3}>
                <Form.Label className={'label'}>木曜日</Form.Label>
                <Select
                  name="thursday"
                  value={selectedThursdayOpenTimeOption}
                  options={availableThursdayOpenTimes.map((v) => {
                    return { value: v, label: v };
                  })}
                  onChange={(selectedOption: any) => {
                    setSelectedThursdayOpenTimeOption(selectedOption);
                  }}
                />
              </Col>
              <Col md={3}>
                <Form.Label className={'label'}>金曜日</Form.Label>
                <Select
                  name="friday"
                  value={selectedFridayOpenTimeOption}
                  options={availableFridayOpenTimes.map((v) => {
                    return { value: v, label: v };
                  })}
                  onChange={(selectedOption: any) => {
                    setSelectedFridayOpenTimeOption(selectedOption);
                  }}
                />
              </Col>
            </Row>
          </div>
        </Form.Group>
        <Form.Group controlId="input">
          {/* @ts-ignore Occurs during typescript migration. The variant does not contain brand-purple, but we have not yet confirmed which color is appropriate. */}
          <Button type="submit" variant="brand-purple" disabled={!isFormValid()}>
            変更する
          </Button>
        </Form.Group>
      </Form>
    </div>
  );
};
